export const getFirstAndLastName = (fullName) => {
  if (!fullName) return ""; // Retorna uma string vazia se o nome estiver vazio ou indefinido
  const names = fullName.trim().split(" ");
  if (names.length < 2) return fullName; // Retorna o nome original se for um nome só
  return `${names[0]} ${names[names.length - 1]}`;
};
